let requestSeq = 0;

/** Full chat/archive list fetch — backend defaults to pageSize 10 if omitted. */
export function chatListFullPayload() {
  return {
    pageSize: 1000,
    page: 1,
    updatedAt: "",
  };
}

function responseChatId(data: any): number | null {
  if (data == null || typeof data !== "object") return null;
  if (data.chat_id != null && data.chat_id !== "") {
    const n = Number(data.chat_id);
    return Number.isFinite(n) ? n : null;
  }
  const pinRecords = data?.pinned_messages?.Records;
  if (Array.isArray(pinRecords)) {
    for (const m of pinRecords) {
      if (m?.chat_id == null || m?.message_type === "date") continue;
      const n = Number(m.chat_id);
      if (Number.isFinite(n)) return n;
    }
  }
  const records = data?.message_list?.Records;
  if (!Array.isArray(records)) return null;
  for (const m of records) {
    if (m?.chat_id == null || m?.message_type === "date") continue;
    const n = Number(m.chat_id);
    if (Number.isFinite(n)) return n;
  }
  return null;
}

/**
 * Emit + wait for a matching socket response.
 * Correlates by request_id (preferred) and/or chat_id so concurrent
 * message_list calls cannot resolve each other's promises.
 */
export const socketQuery = (
  socket: any,
  eventName: any,
  payload: any,
  responseEventName: any,
) => {
  return new Promise((resolve, reject) => {
    const request_id =
      payload?.request_id ??
      `${Date.now().toString(36)}-${(++requestSeq).toString(36)}`;
    const requestChatId =
      payload?.chat_id != null && payload.chat_id !== ""
        ? Number(payload.chat_id)
        : null;
    const finalPayload = { ...(payload || {}), request_id };

    const timeout = setTimeout(() => {
      socket.off(responseEventName, onData);
      reject(new Error("Socket timeout"));
    }, 15000);

    const finish = (data: any, asError?: string) => {
      clearTimeout(timeout);
      socket.off(responseEventName, onData);
      if (asError) reject(new Error(asError));
      else resolve(data);
    };

    const onData = (data: any) => {
      // Legacy string errors (no meta) — only accept if we cannot correlate
      if (typeof data === "string") {
        if (requestChatId != null) return;
        finish(null, data);
        return;
      }

      if (data == null || typeof data !== "object") return;

      const rid = data.request_id;
      if (rid != null && String(rid) !== String(request_id)) return;

      const chatId = responseChatId(data);
      if (
        rid == null &&
        requestChatId != null &&
        chatId != null &&
        chatId !== requestChatId
      ) {
        return;
      }

      // Empty list without chat_id/request_id echo — do not steal another request
      if (
        rid == null &&
        requestChatId != null &&
        chatId == null &&
        Array.isArray(data?.message_list?.Records) &&
        data.message_list.Records.length === 0
      ) {
        return;
      }

      if (data.error && typeof data.error === "string") {
        finish(null, data.error);
        return;
      }

      finish(data);
    };

    socket.on(responseEventName, onData);
    socket.emit(eventName, finalPayload);
  });
};

/** First real message chat_id from a message_list payload (API or Redux). */
export function messageListPayloadChatId(data: any): number | null {
  return responseChatId(data);
}
